import { connect } from "react-redux";
import * as actions from "../../actions/scheduleMTO";
import * as actionsFaculty from "../../actions/faculty";
import * as actionsGroup from "../../actions/group";
import * as actionsLk from "../../actions/lk";
import ScheduleMTO from "../../components/dashboard/scheduleMTO/ScheduleMTO";
import * as actionsUni from '../../actions/report';


const mapStateToProps = ({
  schedule,
  faculty,
  group,
  lk,
  auth: { isTeacher },
  report,
}) => ({
  schedule: schedule.schedule,
  groups: schedule.groups,
  type: "teacher",
  facultyList: faculty.list,
  yearsList: group.years,
  educationYear: schedule.educationYear,
  isLoading: schedule.isLoading,
  lkData: lk.data,
  edyId: schedule.edyId,
  isTeacher,
  university: report.university
});

const mapDispatchToProps = (dispatch) => ({
  fetchFaculty: (urlPrefixMTO) => dispatch(actionsFaculty.list(urlPrefixMTO)),
  fetchSchedule: (facultyId, edyId, scyId, monthId, urlPrefixMTO) => dispatch(actions.schedule(facultyId, edyId, scyId, monthId, urlPrefixMTO)),
  fetchYears: () => dispatch(actionsGroup.schoolYear()),
  fetchEducationYear: () => dispatch(actions.educationYear()),
  fetchLkData: () => dispatch(actionsLk.lk()),
  setInitialScehedule: () => dispatch(actions.setInitialScehedule()),
  getUniversity: () => dispatch(actionsUni.getUniversity())

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduleMTO);
